import topFilter from "./topFilter.service";

const topFilterTruckTyreService = {
  async fetchPossibleValues(params) {
    return topFilter.fetchPossibleValues('/catalog/api/truck/tyre/filter-preparation', params);
  },
  async searchProducts(params) {
    return topFilter.searchProducts('/catalog/api/truck/tyre/search', params);
  },
};

export default topFilterTruckTyreService;
